import React, { Component } from "react";
class Cleopatrons extends Component {
  render() {
    return (
      <section className="col-7 nested">
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I registered for India Film Project Season 11's 7 Day Design
            Challenge - Fan Art. The prompt was - 'What if your favourite
            Creators/Public figure/Sportsman had a Different Job/Profession.'
          </p>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I chose Cleopatra because she was a pretty mysterious figure and
            would fit a different profession.
          </p>
          <p className="reflections col-2">
            It was either going to be her or Marilyn Monroe for me.
          </p>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            There is a One Piece character, Shakky who runs 'Shakky's rip-off
            bar' that I really love and she dons the classic Cleopatra bob so I
            decided to make Cleopatra a bartender. Might as well, right?
          </p>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Shakky"
              src={require("../assets/images/cleopatrons/shakky.jpg")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            Her bar is pretty cool too.
          </p>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Shakky's Rip-Off Bar Interior"
              src={require("../assets/images/cleopatrons/Rip-Off_Bar_Inside.webp")}
            />
          </div>
        </div>
        <h2 className="large-spacer-top col-5">Initial Concepts</h2>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Attempt 1"
              src={require("../assets/images/cleopatrons/cleo-bar.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Attempt 2"
              src={require("../assets/images/cleopatrons/cleo-a2.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Attempt 3"
              src={require("../assets/images/cleopatrons/cleo-and-tonys-bar.png")}
            />
          </div>
          <p className="reflections col-2">
            Tony referring to Marc Antony. Shakespeare wrote an entire play
            about them.
          </p>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Attempt 4"
              src={require("../assets/images/cleopatrons/cleo-back-view.png")}
            />
          </div>
        </div>
        <h2 className="large-spacer-top col-5">The Sketch</h2>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I couldn't decide Cleopatra's look until I remembered Aubrey Plaza
            did that one episode of Drunk History as Cleopatra with Comedy
            Central.
          </p>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Aubrey Plaza oof"
              src={require("../assets/images/cleopatrons/aubrey.webp")}
            />
          </div>
          <p className="reflections col-2">
            <a
              className="social-media-link"
              href="https://www.youtube.com/watch?v=5ab4rYDR0yY"
              target="blank"
            >
              It's SUCH a good episode. (Here's the link)
            </a>
          </p>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I wanted her to have a headband for some reason but I scratched that
            pretty quickly. 😐
          </p>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Aubrey with a headband"
              src={require("../assets/images/cleopatrons/aubrey-with-a-headband.jpg")}
            />
          </div>
          <p className="reflections col-2">I just couldn't picture it.</p>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            So I tried my best on paper.
          </p>
        </div>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Sketch"
              src={require("../assets/images/cleopatrons/cleopatra-bartender-sketch.jpg")}
            />
          </div>
        </div>
        <h2 className="large-spacer-top col-5">The Drafts</h2>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            The reason I really wanted to take this challenge was so could I get
            better at using Adobe Illustrator. Here's what came out.
          </p>
        </div>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ✨
            </span>{" "}
            Draft 1
          </strong>{" "}
        </h3>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Draft 1"
              src={require("../assets/images/cleopatrons/cleos-bar-draft-1.jpg")}
            />
          </div>
        </div>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ✨
            </span>{" "}
            Draft 2
          </strong>{" "}
        </h3>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Draft 2"
              src={require("../assets/images/cleopatrons/cleos-bar-draft-2.jpg")}
            />
          </div>
        </div>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ✨
            </span>{" "}
            Draft 2.5 aka Silver Draft
          </strong>{" "}
        </h3>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Draft 2.5"
              src={require("../assets/images/cleopatrons/cleos-bar-draft-2.5-silver-draft.jpg")}
            />
          </div>
        </div>
        <h3 className="project-subheading medium-spacer-top col-5">
          <strong>
            <span role="img" aria-label="sparkle">
              ✨
            </span>{" "}
            Draft 3 aka Final Draft aka Silver Draft
          </strong>{" "}
        </h3>
        <div className="text-group">
          <div className="col-5 medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Final Draft"
              src={require("../assets/images/cleopatrons/cleos-bar-draft-3-silver-draft.jpg")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-5">
            I didn't actually win the competition because there were some{" "}
            <a
              className="social-media-link"
              href="https://indiafilmproject.co/previous-winners-design/"
              target="blank"
            >
              really great entries
            </a>{" "}
            but I've always loved Cleopatra so I'm glad I have this poster now.
          </p>
        </div>
      </section>
    );
  }
}

export default Cleopatrons;
